import React from 'react';
import PropTypes from 'prop-types';
import Router from 'next/router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { sortNumericallyDesc, sortByTimeAsc, sortByTimeDesc, singular, isAutoPlaylist, isEpisodeExplicitlyMarkedPlayed } from '../../lib/utils';
import { PLAYLIST_OLDEST_TO_NEWEST_PODCAST, PLAYLIST_OLDEST_TO_NEWEST, PLAYLIST_NEWEST_TO_OLDEST, QUEUE } from '../../lib/strings';

// import PodcastEpisodeList from '../components/Podcast/PodcastEpisodeList';
import {
    deletePlaylist, fetchPlaylistDetails, fetchPlaylistInfo, deletePlaylistPersonal, deleteAllFromPlaylist,
    playlistEpisodeOrdinalityChanged, playlistSortOrderChanged, queueEpisodeOrdinalityChanged
} from '../../actions';
import { SettingOutlined, CaretDownFilled, CaretUpFilled } from '@ant-design/icons';
// import { PRIVATE } from '../actions/types';
import memoizeOne from 'memoize-one';

import { Modal } from 'antd';
import { spacing, fixedSpacing } from '../../lib/theme';
import PodcastEpisode from './PodcastEpisode';
const { confirm } = Modal;
// const isServer = typeof window === 'undefined';
const ordinalityIncrementValue = 10000;

class PodcastEpisodeReorderableList extends React.Component {


    onDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        console.dir(result);
        const { podcastEpisodes, playlistMainInfo, playlistId, parent } = this.props;
        // const { sortOrder } = this.state;
        // let playlistEpisodeInfo = userPlaylistsMain[`${playlistId}`] || '';
        // let episodes = playlistMainInfo && playlistMainInfo.episodes;
        let sortOrder;
        if (parent == QUEUE) {
            sortOrder = sortByTimeAsc;
        } else {
            let sortOrderMain = playlistMainInfo && playlistMainInfo.sortOrder || 'EARLIEST_FIRST';
            sortOrder = sortOrderMain === 'EARLIEST_FIRST' ? sortByTimeAsc : sortByTimeDesc;
        }

        let sortedEpisodes = Object.values(podcastEpisodes).sort(sortOrder);
        let sourceIndex = result.source.index;
        let destinationIndex = result.destination.index;
        let episodeMoved = sortedEpisodes[sourceIndex];
        let newOrdinality;
        let originalEpisodeAtLocation = sortedEpisodes[destinationIndex];
        let originalEpisodeNearLocation;
        if (sourceIndex < destinationIndex) { /// moving from up to below
            originalEpisodeNearLocation = sortedEpisodes[destinationIndex + 1] || {};
        } else if (sourceIndex > destinationIndex) { /// moving from below to up
            originalEpisodeNearLocation = sortedEpisodes[destinationIndex - 1] || {};
        } else {
            return;
        }
        const now = new Date();
        if (destinationIndex == 0) {
            if (sortOrder === sortByTimeAsc) {
                newOrdinality = originalEpisodeAtLocation.ordinalityDate - ordinalityIncrementValue;
            } else {
                /// this is to make sure it doesn't go beyond any newly added episode
                newOrdinality = Math.round((originalEpisodeAtLocation.ordinalityDate + now.getTime()) / 2);
            }
        } else if (destinationIndex == sortedEpisodes.length - 1) {
            if (sortOrder === sortByTimeAsc) {
                /// this is to make sure it doesn't go beyond any newly added episode
                newOrdinality = Math.round((originalEpisodeAtLocation.ordinalityDate + now.getTime()) / 2);
            } else {
                newOrdinality = originalEpisodeAtLocation.ordinalityDate - ordinalityIncrementValue;
            }
        } else {
            newOrdinality = Math.round((originalEpisodeAtLocation.ordinalityDate + originalEpisodeNearLocation.ordinalityDate) / 2);
        }
        if (parent == QUEUE) {
            this.props.queueEpisodeOrdinalityChanged(episodeMoved.guid, newOrdinality, true);
        } else {
            this.props.playlistEpisodeOrdinalityChanged(playlistId, episodeMoved.guid, newOrdinality);
        }
    }

    podcastEpisodesFn = memoizeOne((podcastEpisodes, sortOrder) => {
        return Object.values(podcastEpisodes).sort(sortOrder);
    })

    render() {
        const { podcastEpisodes, playlistMainInfo, playlistId, playlistInfo, parent } = this.props;

        let sortOrder;
        if (parent == QUEUE) {
            sortOrder = sortByTimeAsc;
        } else {
            let sortOrderMain = playlistMainInfo && playlistMainInfo.sortOrder || 'EARLIEST_FIRST';
            sortOrder = sortOrderMain === 'EARLIEST_FIRST' ? sortByTimeAsc : sortByTimeDesc;
        }
        // let sortOrderMain = playlistMainInfo && playlistMainInfo.sortOrder || 'EARLIEST_FIRST';
        // let sortOrder = sortOrderMain === 'EARLIEST_FIRST' ? sortByTimeAsc : sortByTimeDesc;
        // console.dir(Object.values(podcastEpisodes).sort(sortOrder));
        return (
            <div>
                <DragDropContext onDragEnd={this.onDragEnd}>
                    <Droppable droppableId="droppable">
                        {(provided, snapshot) => (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                            //   style={getListStyle(snapshot.isDraggingOver)}
                            >
                                {
                                    podcastEpisodes.map((episode, index) => (
                                        <Draggable key={episode.guid} draggableId={episode.guid} index={index}>
                                            {(provided, snapshot) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                // style={getItemStyle(
                                                //     snapshot.isDragging,
                                                //     provided.draggableProps.style
                                                // )}
                                                >
                                                    <PodcastEpisode key={episode.pubDate} podcastEpisode={episode} parent={parent}
                                                        fromPlaylistId={playlistId}
                                                        playlistId={playlistId}
                                                        playlistInfo={playlistInfo}
                                                        podcastEpisodes={this.podcastEpisodesFn(podcastEpisodes, sortOrder)} />
                                                </div>)}
                                        </Draggable>
                                    ))
                                }
                                {provided.placeholder}
                            </div>)}
                    </Droppable>
                </DragDropContext>
            </div>
        )
    }
}


PodcastEpisodeReorderableList.propTypes = {
    podcastEpisodes: PropTypes.array,
    parent: PropTypes.string,
    playlistMainInfo: PropTypes.object,
    playlistInfo: PropTypes.object,
    playlistId: PropTypes.string,
    playlistEpisodeOrdinalityChanged: PropTypes.func,
    queueEpisodeOrdinalityChanged: PropTypes.func,
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails,
        loadingState: state.loadingState,
        userPlaylists: state.userPlaylists,
        userPlaylistsMain: state.userPlaylistsMain,
        subscribedPodcasts: state.podcastState,
        personalMarkPlayedValues: state.personalMarkPlayedValues,
    }
}

// export default withRedux(initStore, null, null)(Personal)
const mapDispatchToProps = (dispatch) => {
    return {
        playlistEpisodeOrdinalityChanged: bindActionCreators(playlistEpisodeOrdinalityChanged, dispatch),
        queueEpisodeOrdinalityChanged: bindActionCreators(queueEpisodeOrdinalityChanged, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PodcastEpisodeReorderableList);